<template>
  <CRow>
    <CCol col="12" xl="12">
      <CCard>
        <CCardHeader>
          Reports
        </CCardHeader>
        <CCardBody>
          <stack-modal
                  :show="show"
                  :title="modelTitle"
                  @close="show=false"
                  :hasBackdrop="false"
                  :modal-class="{ [modalClass]: true }"
                  :class="{ customScrollModel: isActive }"
          >
              <p v-if="modelMessage">{{modelMessage}}</p>
             <table class="table" v-if="reasonLists">
               <thead>
                 <tr>
                   <th>Name</th>
                   <th>Reason</th>
                 </tr>
               </thead>
               <tbody v-for="reasonList in reasonLists">
                 <tr>
                   <td>
                       <span class="userLink" @click="redirectUserDetails('/users-details/'+reasonList.user_id)">{{reasonList.firstname}} {{reasonList.lastname}}</span>
                   </td>
                   <td>{{reasonList.reason_name}}</td>
                 </tr>
               </tbody>
             </table>
            <div slot="modal-footer">
              <slot name="modal-footer">
                <div class="modal-footer">
                    <button class="btn btn-danger" v-if="showOkBtn" @click="ok">Ok</button>
                    <button class="btn btn-primary" @click="cancel">Cancel</button>
                </div>
            </slot>
            </div>
          </stack-modal>
          <loading :active.sync="isLoading"
          :can-cancel="false"
          :on-cancel="onCancel"
          :is-full-page="fullPage"></loading>
          <v-client-table v-bind:data="ReportList" v-bind:columns="columns" :options="options" id="dataTable" class="report-list">
            <span slot="createddate" slot-scope="props">{{ props.row.createddate | momentDate }} </span>
            <span slot="username" class="userLink" slot-scope="props" @click="redirectUserDetails('/users-details/'+props.row.matched_user_id)">{{props.row.userName}}</span>
            <img slot="advertphoto" style="width: 100px; height: 100px;" slot-scope="props" :src="props.row.adwardphoto" @error="$event.target.src = APP_URL+'no_image.png'" />
            <span slot="contact" slot-scope="props">{{props.row.contactnumber}}</span>
            <span v-if="props.row.email" slot="email" slot-scope="props">{{props.row.email}}</span><span slot="email" slot-scope="props" v-else>N/A</span>
            <span slot="rpeortcount" class="userLink" title="View reason list" slot-scope="props" @click="openPopup('', props.row.matched_advert_id,'REASONLIST')">{{props.row.reportcount}}</span>
            <span slot="action" slot-scope="props">
                <ul class="list-inline mb-0 text-center">
                    <li class="list-inline-item">
                        <button class="edit-link" data-toggle="tooltip" data-placement="top" title="Block User" @click="openPopup(props.row.matched_user_id,props.row.matched_advert_id,'BLOCK')">
                            <font-awesome-icon :icon="['fas', 'ban']" />
                        </button>
                    </li>
                    <li class="list-inline-item">
                        <button class="delete-link" data-toggle="tooltip" data-placement="top" title="Remove Advert" @click="openPopup(props.row.matched_user_id,props.row.matched_advert_id,'ADVERT')">
                            <font-awesome-icon :icon="['far', 'trash-alt']" />
                        </button>
                    </li>
                </ul>
            </span>
          </v-client-table>
        </CCardBody>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
import axios from 'axios';
import moment from 'moment'
import VueNotifications from 'vue-notifications'
import StackModal from '@innologica/vue-stackable-modal'
// Import component
import Loading from 'vue-loading-overlay';
// Import stylesheet
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
    name: 'ReportList',
    data() {
        return {
            show: false,
            modalClass: '',
            modelTitle: '',
            modelMessage: '',
            userId: '',
            adverId: '',
            status: '',
            showAddBtn: true,
            isLoading: false,
            fullPage: true,
            showOkBtn: true,
            reasonLists: '',
            ReportList: [],
            isActive: false,
            columns: ['createddate', 'username', 'advertphoto', 'contact', 'email', 'rpeortcount', 'action'],
            token: localStorage.getItem('token'),
            API_URL: API_URL,
            APP_URL: APP_URL,
            tokenChange: JSON.parse(localStorage.getItem('token')),
            options: {
              headings: {
                createddate: 'Created Date',
                username: 'User Name',
                advertphoto: 'Advert Photo',
                contact: 'Phone',
                email: 'Email',
                rpeortcount: 'Count',
              },
              sortable: ['createddate', 'username', 'contact', 'email','rpeortcount'],
              sortIcon: { base:'fa', up:'fa-sort-asc', down:'fa-sort-desc', is:'fa-sort' },
              pagination: {
                chunk: 5,
                edge: false,
                nav: 'scroll'
              },
              texts:{
                filterPlaceholder:"Search",
                filter:"Search",
                count: "Showing {from} to {to} of {count} records"
                // count: "Showing {from} to {to} of {count} records|{count} records|One record"
              },
            }
        }
    },
    components: {
        Loading,
        StackModal
    },
    notifications: {
        showErrorMsg: {
            type: VueNotifications.types.error
        },
        showSuccessMsg: {
            type: VueNotifications.types.success
        }
    },
    created() {
        document.title = "Report list";
        this.loadData();
    },
    methods: {
        loadData() {
            this.isLoading = true;
            axios.get(`${API_ADMIN_URL}/getSubmittedReports/`, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.ReportList = response.data.data;
                    this.isLoading = false;
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
        },
        moment: function (date) {
          return moment(date);
        },
        openPopup: function(userId, adverId, status) {
          this.userId = userId;
          this.adverId = adverId;
          this.status = status;

          if (status == 'BLOCK') {
            this.modelTitle = 'Block User';
            this.modelMessage = 'Are you sure you want to block this user ?';
            this.reasonLists = '';
            this.showOkBtn = true;
            this.isActive = false;
          }
          else if(status == 'ADVERT') {
            this.modelTitle = 'Delete Advert';
            this.modelMessage = 'Are you sure you want to delete this advert ?';
            this.reasonLists = '';
            this.showOkBtn = true;
            this.isActive = false;
          }
          else if(status == 'REASONLIST') {
            this.modelTitle = 'Reason List';
            axios.post(`${API_ADMIN_URL}/listofUsersreported/`, {adverId: adverId}, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.reasonLists = response.data.data;
                    this.modelMessage = false;
                    this.showOkBtn = false;
                    this.isActive = response.data.data.length > 5 ? true : false;
                } else {
                    this.show=false
                }
            });
          }
          this.show=true
        },
        cancel() {
          this.deleteUserId = '';
          this.show = false
        },
        ok() {
          if(this.userId && this.adverId && this.status)
          {
            this.isLoading = true;
            let obj = {
              'userId':this.userId,
              'adverId':this.adverId,
              'status':this.status
            }

            axios.post(`${API_ADMIN_URL}/blockUserByAdmin/`, obj, {headers: {'x-access-token': this.tokenChange}}).then(response => {
                if (response.data.status == 200) {
                    this.isLoading = false;
                    this.show = false
                    this.loadData();
                } else {
                    localStorage.clear();
                    this.$router.push('/login');
                }
            });
          } else
          {
            this.show = false
            console.log("Error");
          }
        },
        onCancel() {
          // console.log('User cancelled the loader.')
        },
      redirectUserDetails: function(link) {
        //this.$router.push(link);
        window.open(link, '_blank');
      },
    }
}
</script>
